import { Noun } from '../../types'

const сука: Noun = {
  type: 'noun',
  nominativeSingular: 'сука',
  genitiveSingular: 'суки',
  dativeSingular: 'суке',
  accusativeSingular: 'суку',
  instrumentalSingular: 'сукой',
  prepositionalSingular: 'суке',
  nominativePlural: 'суки',
  genitivePlural: 'сук',
  dativePlural: 'сукам',
  accusativePlural: 'сук',
  instrumentalPlural: 'суками',
  prepositionalPlural: 'суках',
}

export default сука
